import React from 'react';
interface CtaButtonProps {
  href: string;
  children: React.ReactNode;
  size?: 'md' | 'lg';
  external?: boolean;
  className?: string;
}
export function CtaButton({
  href,
  children,
  size = 'md',
  external = false,
  className = ''
}: CtaButtonProps) {
  const base = 'inline-flex w-full items-center justify-center rounded-xl border-2 border-noche bg-oro font-sub font-extrabold uppercase leading-tight tracking-wide text-noche text-center shadow-[0_5px_0_0_rgb(var(--color-naranja))] transition-[transform,background-color,box-shadow] duration-150 ease-out hover:bg-oro-dark active:translate-y-[3px] active:shadow-[0_2px_0_0_rgb(var(--color-naranja))]';
  const sizes: Record<string, string> = {
    md: 'px-4 py-3 text-sm sm:text-base',
    lg: 'px-4 py-3.5 text-base sm:text-lg'
  };
  return <a href={href} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : undefined} className={`${base} ${sizes[size]} ${className}`} data-id="element-180" data-mp="136a8mr23n90u">
      {children}
    </a>;
}